export const ANALYTICS_SAMPLE_TARGET = 5;

export function getAnalyticsSampleProgress(tradeCount, target = ANALYTICS_SAMPLE_TARGET) {
  const normalizedCount = Math.max(0, Number.isFinite(Number(tradeCount)) ? Number(tradeCount) : 0);
  const normalizedTarget = Math.max(1, Number.isFinite(Number(target)) ? Number(target) : ANALYTICS_SAMPLE_TARGET);
  const remaining = Math.max(0, normalizedTarget - normalizedCount);

  return {
    count: normalizedCount,
    target: normalizedTarget,
    remaining,
    isInsufficient: remaining > 0,
  };
}

export function getTodayJournalDestination(returnPath, now = new Date()) {
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();

  return {
    path: `/day/${year}/${month}/${day}`,
    state: {
      date: now.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      }),
      directAdd: true,
      returnPath,
    },
  };
}
